<div class="patient">
  <div class="main-content">
    <header class="l-header">
      <div class="on-mobile header-logo">
        <img src="assets/icons/logo.svg" alt="Artisan Sonics" />
      </div>
      <div class="l-header-panel dsp-flex">
        <div id="1" class="header">
          <h1 class="t-title-main">
            {{
              showPat
                ? ("billing.gui.labels.Issue an Invoice" | translate)
                : ("billing.gui.labels.Billing" | translate)
            }}
          </h1>
        </div>
        <div style="display: flex; justify-content: center; align-items: center; gap: 1em">
          <button class="clear-btn" style="width: fit-content" (click)="goToBillingReports()">
            Reports
          </button>
          <img
            *ngIf="
              loginService.premissions &&
              loginService.premissions.uploadDocuments &&
              patientsService.currentPatient
            "
            style="cursor: pointer"
            matTooltip="{{ 'GUI.documents.tooltips.Attach Document' | translate }}"
            height="46em"
            width="46em"
            (click)="openDocumentsAdd = true"
            src="../../assets/icons/fileupload.svg"
          />
          <img
            *ngIf="patientsService.currentPatient && loginService.clinicalAccess"
            style="cursor: pointer"
            [matTooltip]="'appointments.gui.tooltips.Patient Medical History' | translate"
            (click)="redirectAdministrationPatient()"
            height="41em"
            width="41em"
            src="../../assets/icons/medical-white.svg"
          />
          <img
            *ngIf="
              loginService.premissions &&
              loginService.premissions.Appointments &&
              patientsService.currentPatient
            "
            style="cursor: pointer"
            [matTooltip]="'billing.gui.tooltips.Patient Appointments' | translate"
            height="41em"
            width="41em"
            src="../../assets/icons/calendar-white.svg"
            (click)="goToPatAppointments()"
          />
          <img
            style="cursor: pointer"
            [matTooltip]="'billing.gui.tooltips.Settings' | translate"
            height="41em"
            width="41em"
            src="../../assets/icons/gear-white.svg"
            (click)="goToSettings()"
          />
        </div>
      </div>
    </header>
    <!-- ======= Patient Search Results (Start) ======= -->
    @if (isSearching) {
      <main class="loading-container" [class.is-leaving]="isSearchingFading">
        <img src="assets/images/Wedges.svg" alt="Loading..." class="list-spinner-img" />
      </main>
    } @else if (showEmptyPatients) {
      <p class="empty-state">
        {{ "GUI.Patients.empty.patients" | translate }}
      </p>
    } @else if (showPatientResults) {
      <main class="sub-content">
        <app-pagination-controls
          [total]="totalResults"
          [page]="currentPage"
          [totalPages]="totalPages"
          (prev)="previousPage()"
          (next)="nextPage()"
        ></app-pagination-controls>
        @for (pat of patList; track pat.PID) {
          <div class="l-flex patient-item">
            <button
              class="w100 patient-item-link"
              (click)="selectedPatient = pat; patientsService.setPat(pat)"
              [matTooltip]="'billing.gui.tooltips.Open New Patient' | translate"
            >
              <div class="l-table h100">
                <span class="l-td-m patient-item-cell patient-id">
                  @if (pat.isBusinessClient) {
                    <span>{{ "GUI.Patients.BN ID Number" | translate }}:</span>
                  } @else {
                    <span>{{ patientIdLabel(pat) | translate }}:</span>
                  }
                  <strong>{{ pat.ID }}</strong>
                </span>

                <span class="l-td-m patient-item-cell patient-name-first">
                  {{ pat.First }}
                </span>

                @if (!pat.isBusinessClient) {
                  <span class="l-td-m patient-item-cell patient-name-last">
                    {{ pat.Last }}
                  </span>
                }
                <span class="l-td-m patient-item-cell patient-name-last">
                  {{ patientContact(pat) }}
                </span>
              </div>
            </button>
            <a
              class="l-td-m patient-item-exit"
              (click)="patientsService.setPat(pat); showPat = true"
              [matTooltip]="'billing.gui.tooltips.Open Patient Billing' | translate"
            ></a>
          </div>
        }
        @if (showBottomPatientPager) {
          <app-pagination-controls
            [total]="totalResults"
            [page]="currentPage"
            [totalPages]="totalPages"
            (prev)="previousPage()"
            (next)="nextPage()"
          ></app-pagination-controls>
        }
      </main>
    }
    <!-- ======= Patient Search Results (End) ======= -->

    <aside class="l-sidebar l-flex l-column" style="height: 100%">
      <img class="off-mobile sidebar-logo logo-3d-effect" src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
      <div class="userPanel">
        <i class="userPanel-icon icon-female"> </i>

        <div class="userPanel-userName">
          {{ "billing.gui.labels.Patient Search" | translate }}
        </div>

        <div class="search-patient">
          <div class="search-patient-field">
            <div class="t-field l-flex t-twin-fieldset">
              <label>
                <input
                  type="radio"
                  name="toggleIdPassport"
                  [(ngModel)]="toggleIdPassport"
                  [value]="1"
                  class="custom-check customInput"
                  aria-labelledby="pregnancy_popup-sex"
                />

                <i class="customInput-display"></i>
                <span class="t-field-desc">
                  {{ "billing.gui.labels.ID" | translate }}
                </span>
              </label>
              <label>
                <input
                  type="radio"
                  name="toggleIdPassport"
                  [value]="0"
                  class="custom-check customInput"
                  aria-labelledby="pregnancy_popup-sex"
                />
                <i class="customInput-display"></i>
                <span class="t-field-desc">
                  {{ "billing.gui.labels.Passport" | translate }}
                </span>
              </label>
            </div>
          </div>

          <ng-container *ngIf="loginService.premissions && loginService.premissions.BusinessClients">
            <div class="t-validation-wrap" style="display: flex; margin: 0.5em 0">
              <label class="t-label-top">
                <input
                  type="checkbox"
                  class="custom-check"
                  [(ngModel)]="toggleBusinessClient"
                  [value]="true"
                />
                <span class="customInput-display -sq"></span>
                <span>{{ "appointments.gui.labels.Business Client" | translate }}</span>
              </label>
            </div>
          </ng-container>

          <div class="t-validation-wrap">
            <input
              type="text"
              class="search-patient-field idnumber"
              [ngClass]="invalidi"
              [(ngModel)]="id"
              (keyup)="invalidi = ''; trysearch()"
              [placeholder]="getIDPlaceholder()"
              pattern="[A-Za-z0–9\-]+"
            />
            <div class="t-validation-message">
              <span>
                {{ "billing.gui.labels.Invalid ID Number" | translate }}
              </span>
            </div>
          </div>

          <div class="t-validation-wrap">
            <input
              type="text"
              class="search-patient-field"
              [placeholder]="getNamePlaceholder()"
              [ngClass]="invalidf"
              [(ngModel)]="first"
              (keyup)="invalidf = ''; trysearch()"
            />

            <div class="t-validation-message">
              <span>
                {{ "billing.gui.labels.Please fill in first name" | translate }}
              </span>
            </div>
          </div>

          <ng-container *ngIf="!toggleBusinessClient">
            <div class="t-validation-wrap">
              <input
                type="text"
                class="search-patient-field"
                [placeholder]="'billing.gui.placeholders.Last Name' | translate"
                [ngClass]="invalidl"
                [(ngModel)]="last"
                (keyup)="invalidl = ''; trysearch()"
              />

              <div class="t-validation-message">
                <span>
                  {{ "billing.gui.labels.Please fill in last name" | translate }}
                </span>
              </div>
            </div>
          </ng-container>

          <div class="t-validation-wrap">
            <input
              type="tel"
              class="search-patient-field"
              [placeholder]="'billing.gui.placeholders.Phone' | translate"
              [(ngModel)]="phone"
              (keyup)="invalidf = ''; trysearch()"
            />
            <div class="t-validation-message">
              <span>
                {{ "billing.gui.labels.Invalid phone" | translate }}
              </span>
            </div>
          </div>

          <div class="l-flex l-flex-w t-fieldmargin search-btns">
            <div class="w50">
              <button
                class="search-btn"
                [disabled]="isSearchButtonDisabled"
                matTooltipPosition="after"
                (click)="patientsService.currentPatient = null; search(true)"
                [matTooltip]="'billing.gui.tooltips.Search Patient' | translate"
              >
                {{ "billing.gui.buttons.Search" | translate }}
              </button>
            </div>
            <div class="w50">
              <button
                class="search-btn"
                matTooltipPosition="after"
                (click)="clear()"
                [ngClass]="
                  id.length > 0 || last.length > 0 || first.length > 0 || phone.length > 0
                    ? ''
                    : 'search-btn--clear'
                "
                [matTooltip]="'billing.gui.tooltips.Clear Search Fields' | translate"
              >
                {{ "billing.gui.buttons.Clear" | translate }}
              </button>
            </div>
            <div class="w100">
              <button
                class="search-btn search-btn--newPatient"
                matTooltipPosition="after"
                (click)="addPatient(); isReports = false"
                [matTooltip]="'appointments.gui.tooltips.Open New Patient' | translate"
              >
                {{ toggleBusinessClient ? ("billing.gui.buttons.New Client" | translate) : ("billing.gui.buttons.New Patient" | translate) }}
              </button>
            </div>
            <div class="w100" *ngIf="loginService.clinicalAccess">
              <button
                class="search-btn"
                [matTooltip]="getButtonText()"
                matTooltipPosition="after"
                (click)="redirectAdministration()"
              >
                {{ getButtonText() }}
              </button>
            </div>
            <div class="w100">
              <button
                class="search-btn"
                [matTooltip]="'billing.gui.buttons.Appointments' | translate"
                matTooltipPosition="after"
                *ngIf="loginService.premissions?.Appointments"
                (click)="goAppointments()"
              >
                {{ "billing.gui.buttons.Appointments" | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- <div class="search-help">
          Need help?
          <button class="open-help" (click)="showhelp = true">
            Click Here
          </button>
        </div> -->
      </div>

      <nav class="mainNav l-fg1 scroller"></nav>
      <app-docpanel></app-docpanel>
    </aside>

    <app-bottombar></app-bottombar>
  </div>
</div>
<app-patdetails
  *ngIf="selectedPatient && !typeForm"
  [page]="'billing'"
  [awlLMP]="awlLMP"
  (closed)="onClosed($event)"
></app-patdetails>
<app-pat-documents
  *ngIf="openDocumentsAdd"
  [showDocuments]="false"
  (closed)="openDocumentsAdd = false"
></app-pat-documents>

<app-commerror></app-commerror>
<ng-container *ngIf="showPat">
  <app-patient-info (pageChange)="setPage($event, false)" [isBilling]="true"></app-patient-info>
</ng-container>
